<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img class="img1" src="../assets/logo4.png" alt="">
        <div>
          <span class="span1">全国农村集体资产监管管理平台---金融机构页面</span>
        </div>
      </div>
      <div>
        <span class="span2">当前用户:{{ this.bankName }}管理员{{ this.userName }}</span>
        <el-button type="info" @click="logout">注销</el-button>
      </div>

    </el-header>
    <!-- 页面主体区 -->
    <el-container>
      <!-- 侧边栏菜单区 -->
      <el-aside :width="isCollapse ? '61px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu
              background-color="#333744"
              text-color="#fff"
              active-text-color="#409EFF"
              unique-opened :collapse="isCollapse"
              :collapse-transition="false"
              :default-active="indexFrom"
              router>
          <el-menu-item index="/orgList">
            <i class="el-icon-search"></i>
            <span slot="title" @click="getOrg1()">查询关联合作社</span>
          </el-menu-item>
          <el-menu-item index="/home">
            <i class="el-icon-setting"></i>
            <span slot="title" @click="SetUp()">设置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主本 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <!-- 接受银行名称数据的弹出对话框 -->
    <el-dialog
      title="请选择要进入的金融机构"
      :visible.sync="getDialogVisible"
      width="50%"
      :before-close="handleClose">

      <!-- 银行列表选择 -->
      <el-card class="box-card">
        <div  index="item.id" v-for="item in bankData" :key="item.id">
          <el-tag class="bank-name" type="success" @click="getOrg(item.id, item.name)">{{item.name }}</el-tag>

        </div>
      </el-card>
    </el-dialog>
  </el-container>
</template>

<script>
import { getUserManageFIs, loginInFI, getSubORGListByFI } from '@/api/user'
export default {
  data () {
    return {
      isCollapse: false,
      formData: {
        count: 5,
        offset: 0
      },
      bankData: [],
      orgFromData: {
        FIId: '',
        count: 5,
        offset: 0
      },
      orgData: [],
      indexFrom: '', // 被激活的地址
      getDialogVisible: false,
      bankName: '',
      userName: '',
      cnt: {
        FIId: '',
        userId: undefined
      },
      setUserInfo: []
    }
  },
  methods: {
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    logout () {
      // debugger
      localStorage.removeItem('user')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('indexFrom')
      localStorage.removeItem('setOrgId')
      localStorage.removeItem('setUserInfo')
      localStorage.removeItem('orgFromData')
      localStorage.removeItem('orgData')
      localStorage.removeItem('orgListFYHC')
      localStorage.removeItem('bankData')
      this.$router.push('/login')
    },
    getBank () {
      // debugger
      this.tableLoading = true
      // 查询用户绑定的金融机构
      getUserManageFIs(this.formData).then(res => {
        debugger
        this.tableLoading = false
        if (res.status !== 200) return this.$message.error('远程服务器没有响应')
        if (res.data.c === null) {
          this.$router.push('/login')
          this.$message.error('你没有绑定任何金融机构')
          return
        }
        if (res.data.c === 'invalid token') {
          this.$router.push('/login')
          this.$message.error('登录已失效，请重新登录')
          return
        }

        this.bankData = res.data.c
        localStorage.setItem('bankData', JSON.stringify(this.bankData))
        this.cnt.FIId = this.bankData[0].id
        // 写本地存入token的方法
        this.$store.commit('bankOrg', this.bankData[0].id)
        this.getDialogVisible = true//
      })
    },

    getOrg (key, name) {
      debugger
      // console.log(key)
      this.indexFrom = '/orgList'
      this.orgFromData.FIId = key // 存入选择的银行Id
      localStorage.setItem('orgFromData', JSON.stringify(this.orgFromData))
      this.bankName = name // 存入选择的银行名称
      this.getDialogVisible = false // 关闭银行选择弹框
      localStorage.setItem('indexFrom', JSON.stringify(this.indexFrom))
      this.tableLoading = true
      getSubORGListByFI(this.orgFromData).then(res => {
        this.tableLoading = false
        debugger
        console.log(res.data.c.data)
        this.orgData = res.data.c.data
        this.getOrgName()
        this.$router.push('/orgList')
      })
    },
    getOrg1 () {
      debugger
      this.indexFrom = '/orgList'
      localStorage.setItem('indexFrom', JSON.stringify(this.indexFrom))
      this.$router.push('/orgList')
    },
    getOrgName () {
      debugger
      loginInFI(this.cnt).then(res => {
        debugger
        this.setUserInfo = res.data.c
        localStorage.setItem('setUserInfo', JSON.stringify(this.setUserInfo))
      })
    },
    SetUp () {
      this.indexFrom = '/home'
      localStorage.setItem('indexFrom', JSON.stringify(this.indexFrom))
      this.$router.push('/home')
    }
  },
  created () {
    debugger
    var data1 = JSON.parse(localStorage.getItem('user'))
    var orgBank = JSON.parse(localStorage.getItem('orgFromData'))
    if (orgBank === null) {
      this.getBank()
    }
    this.userName = data1.name
    // if (orgBank.FIId === null) this.getBank() // 如果没有选择了金融机构则查询金融机构
    this.indexFrom = JSON.parse(localStorage.getItem('indexFrom'))
  }
}
</script>

<style lang="less" scoped>
  .home-container{
    height: 100%;
  }
  .el-header{
    background-color: #373D41;
    display: flex;
    justify-content: space-between;
    padding-left: 0;// 左贴边
    align-items: center;// 按键上下居中
    color: aliceblue;
    font-size: 1.25rem;
    > div {
      display: flex;// 居中对齐
      align-items: center;// 标题文本上下居中
      span {
        margin-left: 0.9375rem;// 给图片与标题文本之间加一个间距
      }
      .img1{
        width: 3.125rem;
        height: 3.125rem;
        margin-left: 0.625rem;
      }
    }
  }
  .el-aside{
    background-color: #333744;
    .el-menu{
      border-right: none;
    }
  }
  .el-main{
    background-color: #acbae5;
  }

  .bank-name{
    width: 100%;
    background-color: #4A5064;// 背景色
    font-size: 1.0rem;// 字体大小
    line-height: 1.5rem;// 行高
    color: #fff; // 字体颜色
    text-align: center;// 居中
    letter-spacing: 0.7em;// 字体间距
    cursor: pointer;// 鼠标变手指
    flex-wrap: wrap;// 请允许换行
  }
  .toggle-button{
    width: 100%;
    background-color: #4A5064;// 背景色
    font-size: 0.9375rem;// 字体大小
    line-height: 1.5rem;// 行高
    color: #fff; // 字体颜色
    text-align: center;// 居中
    letter-spacing: 0.3em;// 字体间距
    cursor: pointer;// 鼠标变手指
  }
  .span2 {
    font-size: 0.5rem; // 字体大小
  }
  .span1{
    color: #ffaa00;
  }
</style>
